import { BasePath } from '@constants/Auth';
import { BRAND_NAME, LOGO_URL } from '@constants/Validation';
import { Trans } from '@lingui/macro';
import { Box, Typography } from '@material-ui/core';
import { useAuth } from '@swyft/auth';
import { MainNavMenu as MainNavMenuSwyft } from '@swyft/ui';
import { useAppContext } from '@utils/appState';
import { parseJwt } from '@utils/parseJwt';
import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';

export const MainNavMenu = (): ReactElement => {
  const {
    state: {
      whiteLabelClient,
      tapfiliate: affiliate,
      companyInformation: { isEnabledSubscription }
    }
  } = useAppContext();

  const { isAuthenticated, signOut, user } = useAuth();
  const affiliateLink = affiliate?.referralLink;

  const history = useHistory();

  const userName = React.useMemo(() => {
    if (user) {
      const payload = parseJwt(user.access_token);
      return payload.name;
    }
    return '';
  }, [user]);

  return (
    <MainNavMenuSwyft
      logoSrc={process.env.PUBLIC_URL + '/' + LOGO_URL}
      isAuthenticated={isAuthenticated}
      userName={userName}
      signOut={() => signOut()}
      noShowLogo={whiteLabelClient}
    >
      {!whiteLabelClient && affiliateLink ? (
        <Box
          display={'flex'}
          mx='auto'
          alignItems='center'
          className='cursor-pointer'
          onClick={() => {
            if (isEnabledSubscription) history.push(`${BasePath}/settings?activeTab=AffiliateDashboard`);
          }}
        >
          <span className='mr-3'>💸</span>
          <Typography variant='body2'>
            <Trans>
              Earn <b>Money</b> by sharing {BRAND_NAME}
            </Trans>
          </Typography>
        </Box>
      ) : (
        <div className='flex-grow' />
      )}
    </MainNavMenuSwyft>
  );
};
